/** Shown when a group would let people from several external companies see each other (ADR-021). */
import type { MixedOrgsDetails } from '@tc/contracts';
import { ApiError } from '../api.ts';
import { useT } from '../i18n.ts';

export function mixedOrgs(err: unknown): MixedOrgsDetails | null {
  return err instanceof ApiError && err.code === 'mixed_external_orgs' ? (err.details as MixedOrgsDetails) : null;
}

export function MixedOrgsWarning({ details, busy, onConfirm, onCancel }: { details: MixedOrgsDetails; busy?: boolean; onConfirm: () => void; onCancel: () => void }) {
  const t = useT();
  return (
    <div className="mixed-warning" role="alert">
      <strong>{t('mixedTitle')}</strong>
      <p>{t('mixedBody', { orgs: details.organizations.join(', ') })}</p>
      {details.canOverride ? (
        <div className="row">
          <button type="button" className="btn small danger-outline" disabled={busy} onClick={onConfirm}>{t('mixedConfirm')}</button>
          <button type="button" className="btn small" onClick={onCancel}>{t('cancel')}</button>
        </div>
      ) : (
        <p className="small">{t('mixedAskAdmin')}</p>
      )}
    </div>
  );
}
